import { createSlice } from '@reduxjs/toolkit';

const Slicersreducers = createSlice({
  name: 'miga',
  initialState: {
    value: 'Inicio',
    sidebaractiv: true,
    opcnav: '',
    opcactsidebar: [],
    ultimaip: '',
    fechultingreso: '',
    nombreCliente: '',
    dataProducts: {},
    balanceTotal: {},
    ocultarFilter: [false, false, false],
    listProductsHome: [],
    initHome: false,
    ProductSelect: [],
    GroupSelect: [],
    Alert: [],
    mostrarImage: true,
  },
  reducers: {
    cambiaruta: (state, action) => {
      state.value = action.payload;
    },
    cambiasidebar: (state, action) => {
      /*
            if(action.payload==false){
                let deslinks=[];
                for(let i=0;i<state.opcactsidebar.length;i++){
                    deslinks.push(false);
                    
                }
                state.opcactsidebar=[...deslinks];
            }*/
      state.sidebaractiv = action.payload;
    },
    opcadmnav: (state, action) => {
      state.opcnav = action.payload;
    },
    activalinkssidebar: (state, action) => {
      state.opcactsidebar = action.payload;
    },
    desactivasidebar: (state, action) => {
      //state.opcactsidebar=action.payload
      let tamañoopcsidebar = state.opcactsidebar.length;
      let desopc = [];
      for (let i = 0; i < tamañoopcsidebar; i++) {
        desopc.push(false);
      }
      state.opcactsidebar = [...desopc];
    },
    actualizaIpyfecha: (state, action) => {
      state.ultimaip = action.payload.ip;
      state.fechultingreso = action.payload.fchingreso;
      state.nombreCliente = action.payload.nombreCliente;
    },
    actualizarProducts: (state, action) => {
      state.dataProducts = action.payload;
    },
    actualizaBalanceTotal: (state, action) => {
      state.balanceTotal = action.payload;
    },
    actualizaFilter: (state, action) => {
      state.ocultarFilter = action.payload;
    },
    actualizaListProductsHome: (state, action) => {
      state.listProductsHome = action.payload;
    },
    actulizaInitHome: (state, action) => {
      state.initHome = action.payload;
    },
    actualizaProductSelect: (state, action) => {
      state.ProductSelect = action.payload;
    },
    actualizaGroupSelect: (state, action) => {
      state.GroupSelect = action.payload;
    },
    actualizaAlert: (state, action) => {
      state.Alert = action.payload;
    },
    cambioImagen: (state, action) => {
      state.mostrarImage = action.payload;
    },
  },
});

export const {
  cambiaruta,
  cambiasidebar,
  opcadmnav,
  activalinkssidebar,
  desactivasidebar,
  actualizaIpyfecha,
  actualizarProducts,
  actualizaBalanceTotal,
  actualizaFilter,
  actualizaListProductsHome,
  actulizaInitHome,
  actualizaProductSelect,
  actualizaGroupSelect,
  actualizaAlert,
  cambioImagen,
} = Slicersreducers.actions;

export default Slicersreducers.reducer;
